import React from 'react';
import { Drawer } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useStore } from '../../../../store';
import FilterComponent from './FilterComponent';
import { useFilterSortContext } from '../context/filter-sort-context';

export const FilterDrawer = (): JSX.Element => {
  const {
    onFilterDrawerHandler,
    openFilterDrawer,
  } = useFilterSortContext();

  const {
    executedReport,
    listsForReport,
  } = useStore();

  const {
    regex,
    quickRanges,
    operators,
    filterFields,
  } = listsForReport.data;

  return (
    <Drawer headerStyle={{ display: 'none' }} onClose={() => onFilterDrawerHandler()} open={openFilterDrawer}>
      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '24px 24px 0 24px' }}>
        <span style={{ fontWeight: 600, fontSize: '24px' }}>Filters</span>
        <CloseOutlined onClick={() => onFilterDrawerHandler()} />
      </div>
      <div>
        <FilterComponent
          regex={regex}
          quickRanges={quickRanges}
          operators={operators}
          filterFields={filterFields}
          submitButtonLabel="Apply filters"
          notEditable={false}
          submitButtonAlwaysEnabled
          reportCollection={executedReport.data.collection}
        />
      </div>
    </Drawer>
  );
};
